import { BrowserRouter, Switch, Route } from "react-router-dom";
// Components
import UpdatePassword from "../views/Update-Password";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path={`/home/:token`} component={UpdatePassword} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
